import { render, staticRenderFns } from "./x-radio-button.vue?vue&type=template&id=524a6918&scoped=true&"
import script from "./x-radio-button.vue?vue&type=script&lang=js&"
export * from "./x-radio-button.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-button.vue?vue&type=style&index=0&id=524a6918&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a6918",
  null
  
)

export default component.exports